<div class="container">
    <div class="header" trans>More Like This...</div>

    <div class="titles">
        <media-view [items]="related" class="full-width small-titles"></media-view>
    </div>
</div>
